import { render, staticRenderFns } from "./dingjinOrderList.vue?vue&type=template&id=92a9f2fc&scoped=true&"
import script from "./dingjinOrderList.vue?vue&type=script&lang=js&"
export * from "./dingjinOrderList.vue?vue&type=script&lang=js&"
import style0 from "./dingjinOrderList.vue?vue&type=style&index=0&id=92a9f2fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a9f2fc",
  null
  
)

export default component.exports